import { Button, Typography } from '@/components';
import { TextStyles } from '@/constants';
import { ButtonSize, ButtonVariant } from '@/interfaces';
import type { CSSProperties } from 'react';
import styled from 'styled-components';

const clampText: CSSProperties = {
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
};

export const SuccessWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
  rowGap: 16,
  width: '100%',
});

export const SuccessTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 2'],
})(({ theme }) => ({
  textAlign: 'center',
  color: theme.colors.highEmphasisBlack,
  ...clampText,
  WebkitLineClamp: 3,
  wordBreak: 'break-word',
}));

export const SuccessSubtext = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})(({ theme }) => ({
  textAlign: 'center',
  color: theme.colors.mediumEmphasisBlack,
  lineHeight: theme.lineHeight[22],
  ...clampText,
  WebkitLineClamp: 3,
  wordBreak: 'break-word',
  marginTop: theme.spacing[4],
}));

export const SuccessImageWrapper = styled.div({
  width: '100%',
  height: 240,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ButtonGroup = styled.div({
  display: 'flex',
  flexDirection: 'column',
  rowGap: 8,
  width: '100%',
});

export const FullSizeBtn = styled(Button).attrs({
  size: ButtonSize.Large,
  truncate: true,
  isPMTButton: true,
})({ width: '100%' });

export const GhostBtn = styled(FullSizeBtn).attrs({
  variant: ButtonVariant.Link,
})(({ theme }) => ({
  width: '100%',
  color: theme.colors.pressedBlack,
  padding: theme.spacing[16],
  '&:hover': {
    textDecoration: 'none !important',
    color: `${theme.colors.inactiveBlack} !important`,
  },
}));
